import { EActionAttribute, EColor, EIcon, EPosition, ESize, ETypographyVariant } from '@core/type';

import { LinkTranslatedStyledAsLink } from '../link-translated';
import { Link } from './Link';
import { LinkGoBackBaseProps } from './interface-link';

export const LinkGoBackBase = ({
  redirection,
  query,
  children,
  onClick,
  startIcon,
  isLink = !!redirection,
  isChangingColorHover = true,
  color = EColor.SECONDARY,
}: LinkGoBackBaseProps): JSX.Element => {
  return isLink ? (
    <LinkTranslatedStyledAsLink
      keyRoute={redirection}
      query={query}
      color={color}
      onClick={onClick}
      startIcon={startIcon || EIcon.CIRCLE_ARROW}
      iconSize={ESize.SM}
      isChangingColorHover={isChangingColorHover}
      variant={ETypographyVariant.BODY3}
      iconOrientation={EPosition.RIGHT}
      iconMargin={8}
    >
      {children}
    </LinkTranslatedStyledAsLink>
  ) : (
    <Link
      as={EActionAttribute.BUTTON}
      color={color}
      onClick={onClick}
      startIcon={startIcon || EIcon.CIRCLE_ARROW}
      iconSize={ESize.SM}
      isChangingColorHover={isChangingColorHover}
      variant={ETypographyVariant.BODY3}
      iconOrientation={EPosition.RIGHT}
      iconMargin={8}
    >
      {children}
    </Link>
  );
};
